(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pl-loaded-tea-flavors"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pl-tea-flavors')) {
    customElements.define('pl-tea-flavors', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.items = Array.from(this.querySelectorAll('[data-tea-item]'));
        this.initialized = true;
        this.pageSize = Number(this.dataset.pageSize) || 12;
        this.page = 0;
        this.expanded = false;
        this.search = this.querySelector('[data-tea-search]');
        this.searchbar = this.querySelector('[data-tea-searchbar]');
        this.toggle = this.querySelector('[data-tea-toggle]');
        this.pagination = this.querySelector('[data-tea-pagination]');
        this.previous = this.querySelector('[data-tea-prev]');
        this.next = this.querySelector('[data-tea-next]');
        this.count = this.querySelector('[data-tea-count]');
        this.empty = this.querySelector('[data-tea-empty]');
        this.toggle.hidden = this.items.length <= this.pageSize;
        this.search.addEventListener('change', event => event.stopPropagation());
        this.search.addEventListener('input', event => {
          event.stopPropagation();
          this.page = 0;
          this.update();
        });
        this.toggle.addEventListener('click', () => {
          this.expanded = !this.expanded;
          this.page = 0;
          this.search.value = '';
          this.update();
          if (this.expanded) this.search.focus();
        });
        this.previous.addEventListener('click', () => { this.page--; this.update(-1); });
        this.next.addEventListener('click', () => { this.page++; this.update(1); });
        this.addEventListener('keydown', event => {
          if (event.key !== 'Escape' || !this.expanded) return;
          event.preventDefault();
          this.expanded = false;
          this.page = 0;
          this.search.value = '';
          this.update();
          this.toggle.focus();
        });
        this.setAttribute('data-enhanced', '');
        this.update();
      }
      disconnectedCallback() {
        if (this.pageAnimation) this.pageAnimation.cancel();
      }
      update(direction = 0) {
        if (this.pageAnimation) this.pageAnimation.cancel();
        const term = this.search.value.trim().toLocaleLowerCase();
        const filtered = this.expanded ? this.items.filter(item => item.dataset.teaName.toLocaleLowerCase().includes(term)) : this.items;
        const pages = Math.max(1, Math.ceil(filtered.length / this.pageSize));
        this.page = Math.max(0, Math.min(this.page, pages - 1));
        const visible = new Set(filtered.slice(this.page * this.pageSize, (this.page + 1) * this.pageSize));
        this.items.forEach(item => { item.hidden = !visible.has(item); });
        this.searchbar.hidden = !this.expanded;
        this.pagination.hidden = !this.expanded;
        this.empty.hidden = filtered.length > 0;
        this.previous.disabled = this.page === 0;
        this.next.disabled = this.page >= pages - 1;
        const start = filtered.length ? this.page * this.pageSize + 1 : 0;
        const end = Math.min((this.page + 1) * this.pageSize, filtered.length);
        this.count.textContent = this.dataset.countLabel.replace('[start]', start).replace('[end]', end).replace('[total]', filtered.length);
        this.toggle.setAttribute('aria-expanded', String(this.expanded));
        this.toggle.textContent = this.expanded ? this.dataset.hideLabel : this.dataset.showLabel.replace('[total]', this.items.length);
        const grid = this.querySelector('[data-tea-grid]');
        if (direction && grid.animate && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.pageAnimation = grid.animate(
[{ transform: `translateX(${direction * 10}px)` }, { transform: 'translateX(0)' }],
            { duration: 220, easing: 'cubic-bezier(0.2, 0.7, 0.2, 1)' }
          );
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
